// WP-0.7 (§18.1 interaction rules): every screen defines an Error state (message + Retry).
// This boundary catches render errors in the content area so one broken screen never
// takes down the whole shell.
import { Component, type ErrorInfo, type ReactNode } from 'react';

interface State {
  error: Error | null;
}

export class AppShellError extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    // Structured client error; wired to the persisted error log endpoint in a later WP.
    console.error('screen error', error, info.componentStack);
  }

  override render(): ReactNode {
    if (this.state.error !== null) {
      return (
        <div className="flex min-h-[40vh] flex-col items-center justify-center text-center">
          <p className="text-ink">Something went wrong on this screen.</p>
          <button
            className="mt-3 rounded-[var(--radius-control)] border border-border px-3 py-1.5 text-sm text-ink"
            onClick={() => {
              this.setState({ error: null });
            }}
          >
            Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
